module.exports = __webpack_public_path__ + "img/polonia_icon.929a1e27.png";